import { createContext, useContext } from 'react';

export const DisableFormContext = createContext(false);
export const DisableFormContextProvider = DisableFormContext.Provider;
export const useDisableFormContext = () => useContext(DisableFormContext);
